module.exports = __webpack_public_path__ + "b7bcc7e4cb277a06a2d82dd5a6725a11.woff2";